import "./ReminderPeriodSettings.scss";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  resetSettings,
  selectUserReminderPeriod,
  setUserReminderPeriod,
  updateGeneralSettings,
} from "../../../../redux/reducers/settingsSlice";
import { setCustomReminderPeriod } from "../../../../redux/reducers/uiSlice";
import { setSettings } from "../../../../redux/reducers/popupSlice";
import arrowUp from "./../../../../assets/images/dialog/settings/arrowUp.svg";
import arrowDown from "./../../../../assets/images/dialog/settings/arrowDown.svg";
import arrowUpGray from "./../../../../assets/images/dialog/settings/arrowUpGray.svg";
import arrowDownGray from "./../../../../assets/images/dialog/settings/arrowDownGray.svg";
import classNames from "classnames";

function ReminderPeriodSettings() {
  const dispatch = useAppDispatch();
  const userDefinedReminderPeriod = useAppSelector(selectUserReminderPeriod);

  const initialValue =
    Number(userDefinedReminderPeriod.value) > 0
      ? Number(userDefinedReminderPeriod.value)
      : 3;

  const [reminderPeriod, setReminderPeriod] = useState(initialValue);
  const [isSettingsModified, setSettingsModified] = useState(false);

  // 🔹 Check modification status dynamically
  useEffect(() => {
    if (reminderPeriod !== initialValue) {
      setSettingsModified(true);
      dispatch(setCustomReminderPeriod(reminderPeriod));
    } else {
      setSettingsModified(false);
    }
  }, [reminderPeriod, initialValue, dispatch]);

  const increase = () => {
    if (reminderPeriod < 28) {
      setReminderPeriod((prev) => prev + 1);
    }
  };

  const decrease = () => {
    if (reminderPeriod > 1) {
      setReminderPeriod((prev) => prev - 1);
    }
  };

  const handleChange = (e: any) => {
    const value = Number(e.target.value);
    if (value >= 1 && value <= 28) {
      setReminderPeriod(value);
    }
  };

  const handleApply = () => {
    dispatch(
      updateGeneralSettings({
        ...userDefinedReminderPeriod,
        value: reminderPeriod,
      })
    ).then((res) => {
      if (res.payload?.data) {
        dispatch(setCustomReminderPeriod(reminderPeriod));
        dispatch(
          setUserReminderPeriod({
            ...userDefinedReminderPeriod,
            value: reminderPeriod,
          })
        );
      } 
    });
  };

  const handleCancel = () => {
    setReminderPeriod(initialValue);
    dispatch(setCustomReminderPeriod(initialValue)); // 🔹 ensure revert visually too
    setSettingsModified(false);
    dispatch(setSettings(false));
  };

  const handleClose = () => {
    dispatch(setSettings(false));
  };

  const handleResetToDefault = () => {
    setReminderPeriod(4);
    setSettingsModified(true);
  };

  return (
    <div className="gs-container">
      <div className="gs-controls-container">
        <div className="gs-group">
          <div className="gs-label">Default Reminder Period</div>
          <div className="gs-input">
            <input
              type="number"
              min={1}
              max={28}
              value={reminderPeriod}
              onChange={handleChange}
              className="gs-input-small"
            />
            <div className="gs-controls">
              <button>
                <img
                  className={classNames({
                    "events-disabled": reminderPeriod >= 28,
                  })}
                  src={reminderPeriod < 28 ? arrowUp : arrowUpGray}
                  alt="Increase"
                  onClick={increase}
                />
              </button>
              <button>
                <img
                  className={classNames({
                    "events-disabled": reminderPeriod <= 1,
                  })}
                  src={reminderPeriod > 1 ? arrowDown : arrowDownGray}
                  alt="Decrease"
                  onClick={decrease}
                />
              </button>
            </div>
            <div className="gs-controls-legend">Working Days</div>
          </div>
        </div>

        <div className="bottom-container">
          <div className="gs-reset-holder">
            <button
              className="settings-button-reset"
              onClick={handleResetToDefault}
            >
              Reset
            </button>
            <div className='settings-reset-title'>Reminder Settings</div>
          </div>
          <div className="gs-button-container">
            {isSettingsModified ? (
              <>
                <button
                  className={classNames("settings-button", "button-oranges")}
                  onClick={handleApply}
                >
                  Apply
                </button>
                <button className="settings-button" onClick={handleCancel}>
                  Cancel
                </button>
              </>
            ) : (
              <button className="settings-button" onClick={handleClose}>
                Close
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReminderPeriodSettings;
